module.exports = __webpack_public_path__ + "img/gawaguchi_pc.e62cdf17.jpg";